<script>
    import { ValueService } from '../../services/ValueService.js';
    import { getContext, setContext } from 'svelte';

    /**
     * @typedef {import('../../services/ValueService.js').ValueCssColor} ValueCssColor
     */

    /**
     * @type {{
     *     bg?: boolean | string | null,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { bg = null, children } = $props();

    const tableBg = $derived(getContext('ly-table-colors')?.value?.next);
    const useBg = $derived(bg !== null ? bg : (tableBg ?? true));

    /** @type {{value:ValueCssColor|null}} */
    let colors = $state({ value: null });
    $effect(() => {
        colors.value = ValueService.splitCssColor(useBg, true);
    });
    setContext('ly-table-thead-colors', colors);
    const thisDivide = $derived(colors.value?.divide || '');
</script>

<thead class="{colors.value?.bg0 || ''} divide-y {thisDivide}">
    {@render children?.()}
</thead>
